import { useState } from "react";
import Modal from 'react-modal';
import useKeypress from "../ownHooks/pressEsc";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";
import { MyModalButtons, MyModalCloseButton, MyModalContentDateInput, MyModalContentRow, MyModalContentTextInput, MyModalForm } from "../StyleSheets/ModalStyle";
import { MyCancelButton, MySaveButton } from "../StyleSheets/GeneralButtonStyles";
var MonitorApi = require('monitor-api');


export default function LinienführungUpdate({ rowEntry, reload, usedFilter, linienVerlInstance }) {
    const [showModal, setShowModal] = useState(false);
    const [upAvailable, setUpAvailable] = useState(false);
    const [myComment, setMyComment] = useState('');
    const [input, setInput] = useState({});
    const [updateObject, setUpdateObject] = useState(new MonitorApi.UpdateLinienverlauf());
    const [classes, setClasses] = useState({});

    const resetClasses = () => {
        setClasses({
            gueltig_bis: "unchanged",
            kommentar: "unchanged"
        });
    }

    const openModal = () => {
        setInput({
            gueltig_bis: rowEntry.original.gueltig_bis,
            kommentar: rowEntry.original.kommentar
        });
        setMyComment(rowEntry.original.kommentar);
        setUpAvailable(false);
        resetClasses();
        setUpdateObject({
            ...updateObject,
            id: rowEntry.original.id
        });
        setShowModal(true);
    }

    const closeModal = () => {
        setShowModal(false);
        setUpdateObject({});
    }

    function changeInputs(e) {
        e.preventDefault();
        setUpdateObject({ ...updateObject, [e.target.id]: e.target.value });
        if (e.target.id === 'kommentar') {
            setMyComment(e.target.value);
        }
        setUpAvailable(true);
        setClasses(pre => ({ ...pre, [e.target.id]: "changed" }));
    }

    useKeypress('Escape', () => {
        closeModal();
    });

    function saving(e) {
        e.preventDefault();
        console.log("speichere: ", updateObject);
        let result = new Promise((resolve) => {
            linienVerlInstance.updateLinienverlauf(updateObject, (error, data, response) => {
                if (error) {
                    FehlerauswertungErrResp(error, response);
                    resolve(error);
                } else {
                    alert(`Änderungen gespeichert`);
                    resolve(data);
                }
            })
        })

        result.then((msg) => {
            reload(usedFilter);
            closeModal()
        })
    }

    return (
        <>
            <button onClick={openModal} className="update-bttn">Bearbeiten</button>
            <Modal isOpen={showModal} className="modal">
                <MyModalCloseButton onClick={closeModal}>&#10007; </MyModalCloseButton>
                <MyModalForm>
                    <h3>Änderungen eintragen:</h3>
                    <MyModalContentRow>
                        <label>Gültigkeitsende:
                            <MyModalContentDateInput
                                value={updateObject.gueltig_bis ? updateObject.gueltig_bis : input.gueltig_bis}
                                id="gueltig_bis"
                                onChange={(e) => changeInputs(e)}
                                className={classes.gueltig_bis}
                            />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Kommentar:
                            <MyModalContentTextInput
                                value={myComment}
                                id="kommentar"
                                onChange={(e) => changeInputs(e)}
                                className={classes.kommentar}
                            />
                        </label>
                    </MyModalContentRow>

                    <MyModalButtons>
                        <MySaveButton type="submit" disabled={!upAvailable} onClick={saving}>Speichern</MySaveButton>
                        <MyCancelButton onClick={closeModal}>Abbruch</MyCancelButton>
                    </MyModalButtons>
                </MyModalForm>
            </Modal>
        </>

    )
}